import { Box } from '@factorialco/deprecated-design-system'
import {
  DataTableFilter,
  FilterType,
  ProjectManagementProjectFilter,
} from 'generated/resources/datatable.graphql'
import { LegalEntityForSelectFragment } from 'generated/resources/graphql'

import useFilter from 'modules/core/components/Filter/base/useFilter'
import { LegalEntitySelector } from 'modules/core/components/LegalEntitySelector'
import i18n from 'modules/core/lib/i18n'

const LegalEntityFilterComponent = () => {
  const { value, onValueChange } = useFilter<LegalEntityForSelectFragment[]>()

  return (
    <Box flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <LegalEntitySelector
        multiple
        hideBorder
        alwaysOpen
        label={''}
        width="s400"
        value={value ?? []}
        onChange={onValueChange}
      />
    </Box>
  )
}

export const LegalEntityFilter = (): DataTableFilter<ProjectManagementProjectFilter> => {
  return {
    type: FilterType.Entity,
    path: 'legalEntityId',
    title: i18n.t('project_management.table.projects_list.headers.legal_entity'),
    identifier: 'newLegalEntityFilter',
    default: true,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'legalName',
        component: () => <LegalEntityFilterComponent />,
      },
    ],
  }
}
